var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _ellipse, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 662,
    height: 441,
    viewBox: "0 0 662 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 117.967V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 117.967V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 117.967H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 142.922H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 167.883H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 192.838H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 217.793H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 242.749H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 267.709H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 292.664H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 317.619H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 342.574H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 367.535H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 392.49H487.673",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 117.967L487.673 142.922",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 117.967L458.987 142.922",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 142.922L487.673 167.883",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 142.922L458.987 167.883",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 167.883L487.673 192.838",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 167.883L458.987 192.838",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 192.838L487.673 217.793",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 192.838L458.987 217.793",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 217.793L487.673 242.749",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 217.793L458.987 242.749",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 242.749L487.673 267.709",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 242.749L458.987 267.709",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 267.709L487.673 292.664",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 267.709L458.987 292.664",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 292.664L487.673 317.619",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 292.664L458.987 317.619",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 317.619L487.673 342.574",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 317.619L458.987 342.574",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 342.574L487.673 367.535",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 342.574L458.987 367.535",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 367.535L487.673 392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 367.535L458.987 392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 117.967L495.948 113.419",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 392.49L495.948 387.942",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M495.948 113.419V387.942",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 117.967L495.948 113.419",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 142.922L495.948 138.375",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 167.883L495.948 163.335",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 192.838L495.948 188.291",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 217.793L495.948 213.246",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 242.748L495.948 238.201",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 267.709L495.948 263.161",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 292.664L495.948 288.116",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 317.619L495.948 313.071",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 342.574L495.948 338.026",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 367.535L495.948 362.987",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 392.49L495.948 387.942",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 117.967L495.948 138.375",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 142.922L495.948 163.335",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 167.883L495.948 188.291",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 192.838L495.948 213.246",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 217.793L495.948 238.201",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 242.749L495.948 263.161",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 267.709L495.948 288.116",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 292.664L495.948 313.071",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 317.619L495.948 338.026",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 342.574L495.948 362.987",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 367.535L495.948 387.942",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M460.09 117.967L473.33 52.9199L486.57 117.967",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M473.33 117.967V52.9199",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M460.09 120.172H471.123V133.402H460.09V120.172Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M463.4 120.172L460.09 123.48",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M466.71 120.172L460.09 126.787",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M470.02 120.172L460.09 130.095",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 119.07L165.5 137.812",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 136.71L165.5 146.632",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 119.07V136.71",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M434.531 120.63V137.537",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M410.07 122.195V138.363",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M385.615 123.755V139.19",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M361.16 125.315V140.017",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M336.699 126.881V140.845",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M312.243 128.441V141.671",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M287.788 130.001V142.498",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M263.327 131.567V143.325",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M238.872 133.127V144.152",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M214.416 134.687V144.979",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M189.955 136.252V145.806",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 137.812V146.632",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M458.987 119.07L434.531 137.537",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M434.531 137.537L410.07 122.195",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M410.07 122.195L385.615 139.19",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M385.615 139.19L361.16 125.315",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M361.16 125.315L336.699 140.844",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M336.699 140.845L312.243 128.441",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M312.243 128.441L287.788 142.498",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M287.788 142.498L263.327 131.567",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M263.327 131.567L238.872 144.152",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M238.872 144.152L214.416 134.687",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M214.416 134.687L189.955 145.806",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M189.955 145.806L165.5 137.812",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M473.33 52.9199L308.933 128.651",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M473.33 52.9199L226.183 133.937",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M473.33 52.9199L176.533 137.107",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 119.07L553.873 124.582",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 136.71L553.873 138.915",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 119.07V136.71",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M504.223 120.448V137.261",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 121.826V137.812",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M537.323 123.204V138.363",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M553.873 124.583V138.915",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M487.673 119.07L504.223 137.261",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M504.223 137.261L520.773 121.826",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 121.826L537.323 138.364",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M537.323 138.364L553.873 124.583",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M473.33 52.9199L540.633 124.582",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M529.6 130.095H554.977V151.042H529.6V130.095Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M533.462 130.095L529.6 133.953",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M537.323 130.095L529.6 137.812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M541.185 130.095L529.6 141.671",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M545.047 130.095L529.6 145.53",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M548.908 130.095L529.6 149.388",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M552.77 130.095L531.807 151.042",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M251.56 143.463H267.007V148.975H251.56V143.463Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M259.283 148.975V249.165",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M254.318 249.165H264.248L262.593 257.985H255.973L254.318 249.165Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M259.283 257.985V260.741C260.074 261.487 260.598 262.471 260.775 263.542C260.951 264.614 260.771 265.714 260.262 266.674C259.753 267.633 258.943 268.399 257.956 268.854C256.969 269.309 255.86 269.428 254.799 269.193C253.738 268.957 252.783 268.38 252.082 267.55C251.381 266.72 250.972 265.683 250.917 264.598C250.862 263.514 251.166 262.441 251.78 261.545C252.395 260.649 253.286 259.979 254.318 259.639",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 206.167V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 206.167V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 206.167H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 224.8H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 243.432H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 262.064H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 280.696H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 299.329H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 317.961H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 336.593H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 355.226H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 373.857H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 392.49H356.928",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 206.167L356.928 224.8",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 206.167L335.965 224.8",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 224.8L356.928 243.432",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 224.8L335.965 243.432",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 243.432L356.928 262.064",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 243.432L335.965 262.064",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 262.064L356.928 280.696",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 262.064L335.965 280.696",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 280.696L356.928 299.329",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 280.696L335.965 299.329",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 299.329L356.928 317.961",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 299.329L335.965 317.961",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 317.961L356.928 336.593",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 317.961L335.965 336.593",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 336.593L356.928 355.226",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 336.593L335.965 355.226",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 355.226L356.928 373.858",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 355.226L335.965 373.858",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 373.857L356.928 392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 373.857L335.965 392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M337.068 206.168L346.447 167.58L355.825 206.168",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 207.27L199.703 232.628",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 220.5L199.703 239.242",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 207.27V220.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M320.827 210.087V222.584",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M305.684 212.904V224.667",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M290.546 215.721V226.746",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M275.403 218.538V228.829",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M260.265 221.36V230.913",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M245.122 224.177V232.997",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M229.984 226.994V235.075",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M214.841 229.811V237.159",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M199.703 232.627V239.242",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 207.27L320.827 222.584",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M320.827 222.584L305.684 212.904",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M305.684 212.904L290.546 226.746",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M290.546 226.746L275.403 218.538",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M275.403 218.538L260.265 230.913",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M260.265 230.913L245.122 224.177",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M245.122 224.177L229.984 235.075",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M229.984 235.075L214.841 229.811",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M214.841 229.811L199.703 239.242",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M346.447 167.58L286.867 216.404",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M346.447 167.58L237.217 225.649",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 207.27L404.923 210.578",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 220.5H404.923",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 207.27V220.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M372.927 208.373V220.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M388.925 209.475V220.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M404.923 210.578V220.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M356.928 207.27L372.927 220.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M372.927 220.5L388.925 209.475",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M388.925 209.475L404.923 220.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M390.58 212.782H406.027V227.115H390.58V212.782Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M393.89 212.782L390.58 216.09",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M397.2 212.782L390.58 219.397",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M400.51 212.782L390.58 222.705",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M403.82 212.782L390.58 226.012",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M214.598 237.109V292.713",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M214.598 292.714L192.532 314.764H236.665L214.598 292.714Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M185.912 314.764H243.285",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M192.532 319.945C193.568 319.945 194.407 319.106 194.407 318.071C194.407 317.036 193.568 316.197 192.532 316.197C191.496 316.197 190.656 317.036 190.656 318.071C190.656 319.106 191.496 319.945 192.532 319.945Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M192.532 314.764V316.417",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M206.875 319.945C207.911 319.945 208.751 319.106 208.751 318.071C208.751 317.036 207.911 316.197 206.875 316.197C205.839 316.197 204.999 317.036 204.999 318.071C204.999 319.106 205.839 319.945 206.875 319.945Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M206.875 314.764V316.417",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M222.322 319.945C223.358 319.945 224.197 319.106 224.197 318.071C224.197 317.036 223.358 316.197 222.322 316.197C221.286 316.197 220.446 317.036 220.446 318.071C220.446 319.106 221.286 319.945 222.322 319.945Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M222.322 314.764V316.417",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M236.665 319.945C237.701 319.945 238.541 319.106 238.541 318.071C238.541 317.036 237.701 316.197 236.665 316.197C235.629 316.197 234.789 317.036 234.789 318.071C234.789 319.106 235.629 319.945 236.665 319.945Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M236.665 314.764V316.417",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 251.37V392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 251.37L294.59 246.96",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M302.865 251.37V392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M302.865 251.37L300.658 246.96",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M308.933 251.37V392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M308.933 251.37L306.727 246.96",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M315.002 251.37V392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M315.002 251.37L312.795 246.96",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M321.07 251.37V392.49",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M321.07 251.37L318.863 246.96",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 392.49H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 377.667H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 362.844H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 348.021H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 333.197H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 318.38H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 303.557H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 288.734H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 273.911H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M296.797 259.087H321.07",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M293.487 392.49V367.132H324.38V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 175.297V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4384 175.297V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4384 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 175.297V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 392.49H137.917",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 356.29H137.917",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 320.094H137.917",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 283.894H137.917",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 247.693H137.917",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 211.498H137.917",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 175.297H137.917",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 354.636H137.917",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 209.844H137.917",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 392.49L95.4383 356.29",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4383 356.289L52.96 320.094",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 320.094L95.4383 283.894",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4383 283.893L52.96 247.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 247.693L95.4383 211.498",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4383 211.498L52.96 175.297",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 392.49L95.4384 356.29",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4384 356.289L137.917 320.094",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 320.094L95.4384 283.894",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4384 283.893L137.917 247.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 247.693L95.4384 211.498",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4384 211.498L137.917 175.297",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 137.812V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 137.812V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 392.49H66.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 356.107H66.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 319.725H66.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 283.342H66.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 246.96H66.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 210.578H66.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 174.195H66.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 137.812H66.2",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 354.454H66.2",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 172.541H66.2",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 392.49L66.2 356.107",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 356.108L33.1 319.725",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 319.725L66.2 283.342",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 283.342L33.1 246.96",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 246.96L66.2 210.578",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 210.577L33.1 174.195",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 174.195L66.2 137.812",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 259.087V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 259.087V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 392.49H165.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 359.139H165.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 325.789H165.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 292.438H165.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 259.087H165.5",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 357.485H165.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 290.784H165.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 392.49L165.5 359.139",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 359.139L137.917 325.789",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M137.917 325.789L165.5 292.438",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 292.438L137.917 259.087",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 127.89V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 127.89V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 127.89V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M626.693 127.89V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M626.693 392.49V397.451",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 392.49H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 359.415H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 326.34H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 293.265H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 260.19H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 227.115H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 194.04H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 160.965H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 127.89H626.693",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 357.761H626.693",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 159.311H626.693",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 392.49L556.08 359.415",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 359.415L520.773 326.34",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 326.34L556.08 293.265",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 293.265L520.773 260.19",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 260.19L556.08 227.115",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 227.115L520.773 194.04",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 194.04L556.08 160.965",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 160.965L520.773 127.89",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 392.49L556.08 359.415",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 359.415L591.387 326.34",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 326.34L556.08 293.265",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 293.265L591.387 260.19",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 260.19L556.08 227.115",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 227.115L591.387 194.04",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 194.04L556.08 160.965",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M556.08 160.965L591.387 127.89",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 392.49L626.693 359.415",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M626.693 359.415L591.387 326.34",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 326.34L626.693 293.265",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M626.693 293.265L591.387 260.19",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 260.19L626.693 227.115",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M626.693 227.115L591.387 194.04",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M591.387 194.04L626.693 160.965",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M626.693 160.965L591.387 127.89",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 162.067V392.49",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 599.11,
    cy: 392.49,
    rx: 0.634417,
    ry: 0.633937,
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 392.49V371.542",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 386.349H614.766",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M614.766 386.349V365.401",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 380.213H625.347",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M625.347 380.214V359.266",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 374.073H627.421",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M627.422 374.072V353.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 367.938H620.322",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M620.322 367.937V346.99",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 361.796H606.337",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M606.337 361.796V340.849",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 355.661H590.013",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M590.013 355.661V334.713",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 349.52H576.641",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M576.641 349.52V328.572",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 343.385H570.55",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M570.55 343.385V322.437",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 337.244H573.717",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M573.717 337.244V316.296",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 331.108H585.12",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M585.12 331.108V310.161",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 324.967H601.057",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M601.057 324.968V304.02",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 318.832H616.361",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M616.361 318.832V297.884",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 312.691H626.075",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M626.075 312.691V291.744",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 306.556H627.046",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M627.046 306.555V285.608",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 300.415H618.959",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M618.959 300.415V279.467",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 294.279H604.439",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M604.439 294.279V273.332",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 288.138H588.187",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M588.187 288.138V267.191",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 282.003H575.482",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M575.482 282.003V261.055",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 275.862H570.434",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M570.434 275.862V254.915",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 269.727H574.682",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M574.682 269.726V248.779",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 263.585H586.852",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M586.852 263.586V242.638",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 257.45H602.994",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M602.994 257.45V236.503",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 251.309H617.878",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M617.878 251.309V230.362",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 245.174H626.677",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M626.677 245.174V224.227",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 239.033H626.539",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M626.539 239.033V218.085",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 232.897H617.508",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M617.508 232.898V211.95",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 226.757H602.514",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M602.514 226.757V205.809",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 220.621H586.411",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M586.411 220.621V199.674",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 214.48H574.428",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M574.428 214.48V193.533",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 208.345H570.451",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M570.451 208.345V187.397",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 202.204H575.758",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M575.758 202.204V181.256",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 196.068H588.639",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M588.639 196.069V175.121",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 189.928H604.914",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M604.914 189.927V168.98",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 183.792H619.306",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M619.307 183.792V162.845",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 177.651H627.151",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M627.151 177.651V156.704",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 171.516H625.904",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M625.904 171.516V150.568",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 165.375H615.969",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M615.969 165.375V144.427",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 392.49L614.766 386.349L625.347 380.214L627.421 374.073L620.322 367.937L606.337 361.796L590.013 355.661L576.641 349.52L570.55 343.385L573.717 337.244L585.12 331.108L601.057 324.967L616.361 318.832L626.075 312.691L627.046 306.556L618.959 300.415L604.439 294.279L588.187 288.138L575.482 282.003L570.434 275.862L574.682 269.727L586.852 263.586L602.994 257.45L617.878 251.309L626.677 245.174L626.539 239.033L617.508 232.898L602.514 226.757L586.411 220.621L574.428 214.48L570.451 208.345L575.758 202.204L588.639 196.069L604.913 189.928L619.306 183.792L627.151 177.651L625.904 171.516L615.969 165.375",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 371.542L614.766 365.401L625.347 359.266L627.421 353.125L620.322 346.99L606.337 340.849L590.013 334.713L576.641 328.572L570.55 322.437L573.717 316.296L585.12 310.161L601.057 304.02L616.361 297.884L626.075 291.743L627.046 285.608L618.959 279.467L604.439 273.332L588.187 267.191L575.482 261.055L570.434 254.914L574.682 248.779L586.852 242.638L602.994 236.503L617.878 230.362L626.677 224.226L626.539 218.085L617.508 211.95L602.514 205.809L586.411 199.674L574.428 193.533L570.451 187.397L575.758 181.256L588.639 175.121L604.913 168.98L619.306 162.845L627.151 156.704L625.904 150.568L615.969 144.427",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M26.48 392.49H635.52",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 392.49L27.5834 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M43.03 392.49L37.5133 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M52.96 392.49L47.4434 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M62.89 392.49L57.3733 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M72.82 392.49L67.3033 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7499 392.49L77.2333 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M92.68 392.49L87.1633 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M102.61 392.49L97.0933 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M112.54 392.49L107.023 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M122.47 392.49L116.953 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M132.4 392.49L126.883 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M142.33 392.49L136.813 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M152.26 392.49L146.743 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M162.19 392.49L156.673 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M172.12 392.49L166.603 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M182.05 392.49L176.533 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M191.98 392.49L186.463 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M201.91 392.49L196.393 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M211.84 392.49L206.323 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M221.77 392.49L216.253 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M231.7 392.49L226.183 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M241.63 392.49L236.113 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M251.56 392.49L246.043 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M261.49 392.49L255.973 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M271.42 392.49L265.903 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M281.35 392.49L275.833 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M291.28 392.49L285.763 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M301.21 392.49L295.693 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M311.14 392.49L305.623 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M321.07 392.49L315.553 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M331 392.49L325.483 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M340.93 392.49L335.413 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M350.86 392.49L345.343 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M360.79 392.49L355.273 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M370.72 392.49L365.203 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M380.65 392.49L375.133 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M390.58 392.49L385.063 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M400.51 392.49L394.993 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M410.44 392.49L404.923 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M420.37 392.49L414.853 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M430.3 392.49L424.783 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M440.23 392.49L434.713 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M450.16 392.49L444.643 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M460.09 392.49L454.573 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M470.02 392.49L464.503 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M479.95 392.49L474.433 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M489.88 392.49L484.363 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M499.81 392.49L494.293 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M509.74 392.49L504.223 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M519.67 392.49L514.153 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M529.6 392.49L524.083 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M539.53 392.49L534.013 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M549.46 392.49L543.943 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M559.39 392.49L553.873 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M569.32 392.49L563.803 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M579.25 392.49L573.733 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M589.18 392.49L583.663 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M599.11 392.49L593.593 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M609.04 392.49L603.523 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M618.97 392.49L613.453 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M628.9 392.49L623.383 399.105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M220.115 392.49C224.685 392.49 228.39 388.788 228.39 384.221C228.39 379.655 224.685 375.953 220.115 375.953C215.545 375.953 211.84 379.655 211.84 384.221C211.84 388.788 215.545 392.49 220.115 392.49Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M220.115 389.182C222.857 389.182 225.08 386.961 225.08 384.221C225.08 381.481 222.857 379.26 220.115 379.26C217.373 379.26 215.15 381.481 215.15 384.221C215.15 386.961 217.373 389.182 220.115 389.182Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M236.665 392.49C241.235 392.49 244.94 388.788 244.94 384.221C244.94 379.655 241.235 375.953 236.665 375.953C232.095 375.953 228.39 379.655 228.39 384.221C228.39 388.788 232.095 392.49 236.665 392.49Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M236.665 389.182C239.407 389.182 241.63 386.961 241.63 384.221C241.63 381.481 239.407 379.26 236.665 379.26C233.923 379.26 231.7 381.481 231.7 384.221C231.7 386.961 233.923 389.182 236.665 389.182Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M253.215 392.49C257.785 392.49 261.49 388.788 261.49 384.221C261.49 379.655 257.785 375.953 253.215 375.953C248.645 375.953 244.94 379.655 244.94 384.221C244.94 388.788 248.645 392.49 253.215 392.49Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M253.215 389.182C255.957 389.182 258.18 386.961 258.18 384.221C258.18 381.481 255.957 379.26 253.215 379.26C250.473 379.26 248.25 381.481 248.25 384.221C248.25 386.961 250.473 389.182 253.215 389.182Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M269.765 392.49C274.335 392.49 278.04 388.788 278.04 384.221C278.04 379.655 274.335 375.953 269.765 375.953C265.195 375.953 261.49 379.655 261.49 384.221C261.49 388.788 265.195 392.49 269.765 392.49Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M269.765 389.182C272.507 389.182 274.73 386.961 274.73 384.221C274.73 381.481 272.507 379.26 269.765 379.26C267.023 379.26 264.8 381.481 264.8 384.221C264.8 386.961 267.023 389.182 269.765 389.182Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M228.39 378.168C232.96 378.168 236.665 374.466 236.665 369.9C236.665 365.333 232.96 361.631 228.39 361.631C223.82 361.631 220.115 365.333 220.115 369.9C220.115 374.466 223.82 378.168 228.39 378.168Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M228.39 374.861C231.132 374.861 233.355 372.64 233.355 369.9C233.355 367.16 231.132 364.938 228.39 364.938C225.648 364.938 223.425 367.16 223.425 369.9C223.425 372.64 225.648 374.861 228.39 374.861Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M244.94 378.168C249.51 378.168 253.215 374.466 253.215 369.9C253.215 365.333 249.51 361.631 244.94 361.631C240.37 361.631 236.665 365.333 236.665 369.9C236.665 374.466 240.37 378.168 244.94 378.168Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M244.94 374.861C247.682 374.861 249.905 372.64 249.905 369.9C249.905 367.16 247.682 364.938 244.94 364.938C242.198 364.938 239.975 367.16 239.975 369.9C239.975 372.64 242.198 374.861 244.94 374.861Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M261.49 378.168C266.06 378.168 269.765 374.466 269.765 369.9C269.765 365.333 266.06 361.631 261.49 361.631C256.92 361.631 253.215 365.333 253.215 369.9C253.215 374.466 256.92 378.168 261.49 378.168Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M261.49 374.861C264.232 374.861 266.455 372.64 266.455 369.9C266.455 367.16 264.232 364.938 261.49 364.938C258.748 364.938 256.525 367.16 256.525 369.9C256.525 372.64 258.748 374.861 261.49 374.861Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M236.665 363.847C241.235 363.847 244.94 360.145 244.94 355.578C244.94 351.012 241.235 347.31 236.665 347.31C232.095 347.31 228.39 351.012 228.39 355.578C228.39 360.145 232.095 363.847 236.665 363.847Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M236.665 360.54C239.407 360.54 241.63 358.318 241.63 355.578C241.63 352.838 239.407 350.617 236.665 350.617C233.923 350.617 231.7 352.838 231.7 355.578C231.7 358.318 233.923 360.54 236.665 360.54Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M253.215 363.847C257.785 363.847 261.49 360.145 261.49 355.578C261.49 351.012 257.785 347.31 253.215 347.31C248.645 347.31 244.94 351.012 244.94 355.578C244.94 360.145 248.645 363.847 253.215 363.847Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M253.215 360.54C255.957 360.54 258.18 358.318 258.18 355.578C258.18 352.838 255.957 350.617 253.215 350.617C250.473 350.617 248.25 352.838 248.25 355.578C248.25 358.318 250.473 360.54 253.215 360.54Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M244.94 349.526C249.51 349.526 253.215 345.824 253.215 341.257C253.215 336.69 249.51 332.988 244.94 332.988C240.37 332.988 236.665 336.69 236.665 341.257C236.665 345.824 240.37 349.526 244.94 349.526Z",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M244.94 346.218C247.682 346.218 249.905 343.997 249.905 341.257C249.905 338.517 247.682 336.295 244.94 336.295C242.198 336.295 239.975 338.517 239.975 341.257C239.975 343.997 242.198 346.218 244.94 346.218Z",
    stroke: "white",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M377.34 392.49H443.54",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5251 334.325C80.1561 334.361 79.7331 334.424 79.5981 334.478C79.4541 334.532 79.2471 334.577 79.1391 334.577C79.0221 334.577 78.6261 334.713 78.2571 334.884C76.4662 335.705 75.3502 337.608 74.9542 340.513C74.8552 341.316 74.7382 341.46 74.0542 341.649C73.4873 341.812 73.0553 342.091 73.0553 342.29C73.0553 342.497 73.4333 342.696 74.3422 342.966C75.9082 343.435 75.9352 343.471 75.9352 344.815C75.9352 347.052 76.3942 348.469 77.5282 349.759C77.9511 350.237 77.9151 350.444 77.3032 351.067C76.4302 351.951 75.4942 352.501 73.7753 353.123C70.5353 354.305 70.5353 354.305 69.8334 355.685C69.0324 357.264 68.2854 359.149 68.1864 359.816C68.0694 360.637 67.9074 360.962 67.4754 361.233C67.0794 361.485 66.7554 361.927 66.7554 362.243C66.7554 362.658 66.6744 362.721 66.1254 362.721C65.5405 362.721 65.4145 362.802 65.1445 363.343C64.9285 363.758 64.9015 363.93 64.9915 364.462C65.0545 364.859 65.0365 364.913 64.7395 365.283C64.3975 365.698 64.3435 365.968 64.5145 366.51C64.5685 366.681 64.6225 367.448 64.6495 368.214C64.7125 370.866 65.1895 371.471 67.5204 371.868C67.9704 371.949 68.5374 372.012 68.7804 372.012C69.3744 372.012 69.8873 372.165 70.2113 372.436C70.3463 372.553 70.6073 372.707 70.7693 372.779C71.1113 372.914 71.1563 373.185 70.9853 373.951C70.2743 377.172 70.2563 377.587 70.7963 377.893C70.9853 377.992 71.0933 378.155 71.1653 378.407C71.2193 378.606 71.3633 378.895 71.4983 379.048C71.9753 379.616 71.9483 380.581 71.4083 382.115C71.2643 382.539 71.0663 383.107 70.9763 383.378C70.6073 384.433 70.1213 387.076 69.9053 389.196C69.8513 389.737 69.7614 390.549 69.7164 391C69.5724 392.353 69.5094 400.516 69.6264 402.501C69.8693 406.506 69.7974 412.487 69.4554 416.077C69.4104 416.573 69.3294 418.341 69.2754 420.001C69.1674 423.095 68.9694 425.223 68.6814 426.207C68.6004 426.486 68.4564 426.964 68.3754 427.262C68.0064 428.498 67.8984 429.12 67.9614 429.679C68.0784 430.681 68.1144 430.591 66.8724 432.268C65.5135 434.117 65.4685 434.145 63.7405 434.433C62.7055 434.596 62.1925 435.083 61.8145 436.246C61.5356 437.067 61.6166 437.509 62.0935 437.744C62.8495 438.123 63.0115 438.15 64.9015 438.204C67.7004 438.267 68.6004 438.077 70.1213 437.103C70.6973 436.733 70.9313 436.706 71.2553 436.959C71.4353 437.103 71.6243 437.139 72.2003 437.139C73.9372 437.139 75.0802 436.851 75.3412 436.337C75.5302 435.985 75.5212 434.839 75.3412 433.396C75.0172 430.834 75.0442 430.581 75.9352 428.119C76.1422 427.551 76.3942 426.856 76.4842 426.585C76.9702 425.232 77.1142 424.348 77.1952 422.346C77.2402 421.281 77.3572 419.775 77.4472 419.008C77.5462 418.242 77.6902 417.105 77.7712 416.483C77.8522 415.86 77.9601 415.03 78.0141 414.633C78.0681 414.236 78.1401 413.136 78.1761 412.198C78.2211 410.845 78.2661 410.43 78.3831 410.213C78.9411 409.212 79.0311 408.698 79.1751 405.658C79.4271 400.129 79.5801 398.622 79.8501 398.622C79.9941 398.622 80.0841 398.911 80.3451 400.219C80.5341 401.103 81.0291 403.06 81.3351 404.08C81.6591 405.18 81.7761 405.64 82.01 406.786C82.28 408.085 82.676 409.726 82.946 410.619C83.585 412.766 83.873 413.822 83.99 414.453C84.062 414.85 84.17 415.355 84.215 415.581C84.269 415.806 84.341 416.329 84.395 416.753C84.44 417.177 84.521 417.845 84.575 418.251C84.62 418.656 84.728 419.649 84.8 420.461C85.052 423.212 85.196 424.565 85.286 424.962C85.457 425.765 85.475 426.477 85.358 427.884C85.169 430.149 85.322 430.87 86.1679 431.745C86.5819 432.169 86.5819 432.169 86.5279 433.008C86.4559 434.19 86.2309 434.74 85.331 436.003C84.854 436.661 84.665 437.13 84.665 437.681C84.665 437.852 84.602 438.177 84.53 438.393C84.143 439.485 85.241 439.936 88.3099 439.927C89.6959 439.927 90.0828 439.882 91.0098 439.629C91.8018 439.421 91.9998 439.16 92.0718 438.258C92.1258 437.644 92.1708 437.509 92.4318 437.184C92.7198 436.824 92.7198 436.824 92.6928 434.199C92.6568 431.574 92.6568 431.574 93.0258 431.285C93.5208 430.888 93.6828 430.554 93.6828 429.905C93.6828 429.31 93.5568 428.922 93.2418 428.534C93.0348 428.281 93.0258 428.263 93.0888 426.64C93.1518 424.926 93.0348 422.562 92.8188 420.912C92.5848 419.216 92.4048 417.466 92.3148 416.122C92.1978 414.408 91.5228 408.815 91.0368 405.613C90.8298 404.233 90.8478 402.239 91.0728 401.418C91.2528 400.733 91.2078 397.892 90.9918 396.367C90.6048 393.679 90.5598 393.093 90.6948 392.281C90.9018 391.036 90.8568 390.495 90.4608 389.466C90.1098 388.564 90.1098 388.564 90.1098 386.4C90.1008 384.568 90.0828 384.171 89.9479 383.838C89.8669 383.621 89.7949 383.378 89.7949 383.287C89.7949 383.035 89.2099 381.619 88.8319 380.96C88.2469 379.95 88.2109 378.146 88.7689 378.146C89.0029 378.146 89.6059 377.794 89.7499 377.569C89.9569 377.253 89.8489 376.748 89.5159 376.513C89.1829 376.279 89.1829 376.107 89.5159 374.953C89.8399 373.789 90.0109 371.976 89.9209 370.497C89.8579 369.297 89.7229 369.649 91.0728 367.43C92.2608 365.481 92.5668 364.597 92.6748 362.676C92.7738 361.079 92.8008 360.836 93.0978 359.068C93.4218 357.11 93.4128 356.362 93.0528 355.496C92.5488 354.323 91.8378 353.728 90.2448 353.159C87.6529 352.248 86.7889 351.662 86.1769 350.381C85.745 349.497 85.439 349.29 84.602 349.281C84.125 349.281 84.125 349.281 84.125 348.577C84.134 347.458 84.242 347.152 84.836 346.529C85.439 345.916 85.745 345.402 85.979 344.662C86.1319 344.166 86.1319 344.121 85.979 343.625C85.709 342.741 85.763 342.632 86.5999 342.299C87.3019 342.028 87.3199 342.01 87.3469 341.694C87.3649 341.514 87.2929 341.171 87.2029 340.928C87.1039 340.684 86.9149 340.053 86.7889 339.52C86.3569 337.789 85.934 336.959 85.016 336.048C83.603 334.64 82.334 334.153 80.5251 334.325Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M141.841 334.947C141.679 334.992 141.445 335.173 141.319 335.335C141.184 335.506 140.878 335.75 140.626 335.885C139.159 336.652 138.394 337.446 137.953 338.646C137.764 339.16 137.404 340.901 137.404 341.279C137.404 341.397 137.287 341.649 137.134 341.839C136.792 342.272 136.792 342.263 137.224 342.605C137.62 342.921 137.656 343.102 137.44 343.526C137.251 343.886 137.305 345.014 137.521 345.348C137.611 345.474 137.674 345.636 137.674 345.708C137.674 345.934 138.196 346.457 138.475 346.511C138.664 346.556 138.763 346.647 138.871 346.908C138.979 347.197 139.474 349.01 139.474 349.145C139.474 349.254 139.159 349.461 138.997 349.461C138.574 349.461 138.16 349.867 137.89 350.552C137.386 351.851 137.179 352.005 135.244 352.609C134.578 352.817 133.822 353.069 133.579 353.159C133.327 353.259 133.093 353.34 133.048 353.34C132.859 353.34 131.374 354.125 131.032 354.413C130.15 355.153 129.61 356.605 129.025 359.834C128.935 360.358 128.773 361.169 128.674 361.639C128.08 364.354 128.017 366.446 128.503 368.061C128.548 368.223 128.62 368.801 128.647 369.333C128.719 370.686 128.818 370.821 129.871 371.083C130.303 371.191 130.942 371.317 131.302 371.372C132.247 371.498 133.084 371.949 133.255 372.409C133.471 372.977 133.264 373.753 132.598 374.899C131.896 376.089 131.779 376.91 132.166 377.722C132.373 378.137 132.472 378.534 132.535 379.093C132.598 379.607 132.697 379.977 132.823 380.185C133.03 380.527 133.021 380.861 132.787 381.574C132.715 381.799 132.571 382.322 132.463 382.746C132.355 383.17 132.211 383.711 132.139 383.964C131.869 384.938 131.626 386.454 131.554 387.572C131.509 388.258 131.365 389.286 131.194 390.053C131.005 390.964 130.879 391.929 130.78 393.255C130.591 395.79 130.636 397.179 131.104 403.448C131.266 405.568 131.122 411.702 130.897 412.279C130.546 413.199 130.519 413.38 130.636 413.948C130.762 414.534 130.645 415.851 130.294 418.016C130.114 419.081 129.826 421.733 129.682 423.654C129.619 424.502 129.529 424.944 129.286 425.683C128.629 427.641 128.638 427.623 128.629 429.021C128.629 430.329 128.629 430.329 128.926 430.834C129.304 431.493 129.304 431.502 128.647 432.737C127.828 434.271 127.009 435.074 125.686 435.642C125.011 435.931 124.795 436.255 124.624 437.248C124.453 438.222 124.741 438.655 125.74 438.952C126.955 439.322 129.079 439.196 130.519 438.673C130.771 438.583 131.068 438.474 131.194 438.447C131.491 438.357 131.626 438.24 131.878 437.852C132.085 437.527 132.085 437.527 133.327 437.482C136.036 437.392 136.639 436.508 136 433.567C135.64 431.88 135.64 431.935 135.964 431.042C136.477 429.652 136.603 428.931 136.864 425.999C136.999 424.493 137.188 423.555 137.53 422.644C137.683 422.247 137.899 420.975 138.034 419.685C138.088 419.189 138.169 418.413 138.214 417.971C138.259 417.52 138.322 416.816 138.349 416.392C138.385 415.968 138.484 414.967 138.583 414.164C138.673 413.362 138.754 412.414 138.754 412.063C138.754 411.548 138.808 411.296 139.033 410.773C139.384 409.952 139.699 408.86 139.825 408.049C140.023 406.695 140.113 405.938 140.194 404.982C140.239 404.431 140.338 403.647 140.419 403.223C140.644 402.05 140.914 400.733 141.094 399.93C141.193 399.533 141.355 398.803 141.463 398.307C141.571 397.81 141.715 397.197 141.778 396.935C141.85 396.683 141.904 396.358 141.904 396.214C141.913 394.401 142.822 396.349 143.614 399.885C143.713 400.354 143.884 401.085 143.974 401.509C144.19 402.438 144.406 403.565 144.559 404.504C144.622 404.882 144.703 405.234 144.73 405.288C144.757 405.333 144.838 405.649 144.91 405.992C144.982 406.326 145.153 407.047 145.306 407.598C145.45 408.139 145.675 409.032 145.809 409.564C145.935 410.105 146.187 410.827 146.367 411.17C146.655 411.756 146.691 411.891 146.763 413.028C146.817 413.704 146.934 414.706 147.033 415.256C147.384 417.159 147.627 419.126 147.753 420.903C147.807 421.624 147.888 422.716 147.942 423.338C147.987 423.961 148.068 425.765 148.113 427.352C148.194 430.744 148.275 431.15 148.959 431.835C149.679 432.557 149.661 432.485 149.643 434.632C149.616 436.968 149.589 436.715 149.94 437.04C150.228 437.32 150.228 437.32 150.228 438.258C150.237 439.286 150.3 439.449 150.84 439.728C151.533 440.089 153.756 440.242 155.187 440.035C156.672 439.818 156.879 439.602 156.978 438.222C157.077 436.86 156.852 436.156 156.024 435.146C155.637 434.677 155.421 434.136 155.142 432.945C154.89 431.844 154.899 431.727 155.25 431.375C156.15 430.509 156.249 429.292 155.556 427.866C155.295 427.334 155.286 427.28 155.385 426.901C155.61 426.044 155.448 421.714 155.088 418.963C154.89 417.421 154.782 416.104 154.728 414.597C154.692 413.731 154.611 412.911 154.503 412.432C154.278 411.386 154.143 410.105 154.143 408.915C154.143 408.373 154.08 407.39 153.999 406.723C153.783 404.918 153.792 402.97 154.035 401.662C154.35 399.975 154.305 399.353 153.648 395.645C153.522 394.969 153.504 394.59 153.567 393.841C153.702 392.109 153.648 391 153.396 390.053C153.018 388.619 152.919 387.671 153.054 386.607C153.171 385.633 153.153 385.479 152.748 383.693C152.667 383.342 152.55 382.773 152.478 382.431C152.406 382.079 152.244 381.348 152.109 380.807C151.983 380.257 151.857 379.724 151.83 379.616C151.749 379.255 151.875 379.003 152.262 378.786C152.892 378.426 153.036 377.776 152.685 376.829C152.505 376.342 152.487 376.17 152.523 374.899C152.586 372.68 152.559 371.363 152.442 370.948C152.316 370.488 152.325 370.47 153.108 369.576C154.089 368.458 155.322 366.239 155.934 364.498C156.276 363.524 156.276 363.217 155.97 362.306C155.628 361.278 155.592 360.746 155.7 358.572C155.781 356.849 155.781 356.56 155.646 355.956C155.169 353.89 154.404 353.213 151.533 352.339C150.831 352.122 150.426 351.96 149.49 351.527C149.184 351.382 148.752 351.229 148.527 351.184C148.014 351.094 147.879 350.976 147.744 350.561C147.573 350.02 147.249 349.434 146.997 349.19C146.772 348.983 146.736 348.983 146.34 349.082C145.711 349.254 145.594 349.1 145.845 348.451C145.953 348.189 146.124 347.693 146.241 347.35C146.412 346.845 146.547 346.629 146.97 346.205C147.825 345.339 148.104 344.274 147.663 343.553C147.438 343.183 147.483 343.066 147.978 342.696C148.545 342.263 148.572 342.109 148.122 341.703C147.798 341.406 147.753 341.316 147.753 340.964C147.753 340.341 147.24 338.393 146.934 337.861C146.547 337.184 146.025 336.679 145.153 336.156C144.748 335.903 144.154 335.542 143.839 335.335C143.218 334.929 142.426 334.776 141.841 334.947Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M44.481 335.2C44.382 335.236 44.184 335.443 44.031 335.66C43.743 336.066 43.689 336.111 43.176 336.336C41.6911 336.986 40.4491 338.501 40.0261 340.17C39.7381 341.334 39.6481 341.613 39.4501 342.1C39.1981 342.723 39.2251 342.822 39.7471 343.192C40.1701 343.48 40.2421 343.823 39.9271 344.103C39.5041 344.482 39.9001 346.349 40.4851 346.737C40.8721 346.998 41.0701 347.558 41.1961 348.712C41.2951 349.687 41.2501 349.858 40.7731 350.237C40.4401 350.507 40.3141 350.706 39.9901 351.473C39.8281 351.851 39.8641 351.833 37.1912 352.988C33.7623 354.467 33.1863 354.801 32.5473 355.694C32.3313 356.001 32.0163 356.443 31.8453 356.668C31.0893 357.679 30.3154 358.987 29.5864 360.502C29.1454 361.404 28.6684 362.315 28.5154 362.541C28.3624 362.766 28.2364 362.974 28.2364 363.01C28.2364 363.046 28.1014 363.289 27.9394 363.551C25.5635 367.303 25.4915 368.341 27.0664 375.756C27.1204 375.981 27.1114 376.306 27.0484 376.63C26.9314 377.19 27.0214 377.686 27.4444 378.868C27.7234 379.625 27.9124 379.734 28.5244 379.49C29.1184 379.255 29.1544 379.292 29.9464 380.581C30.7563 381.889 31.0173 382.061 32.4393 382.232C33.2853 382.331 33.2853 382.331 33.6633 382.773C33.8703 383.026 34.1133 383.288 34.2033 383.369C34.5722 383.693 34.5632 384.199 34.1403 385.867C33.7623 387.374 33.6903 387.969 33.2313 393.21C33.1593 394.031 33.0603 395.14 33.0063 395.691C32.8803 396.972 32.8713 401.446 32.9883 402.321C33.3663 405.018 33.3753 405.081 33.2853 408.473C33.2223 411.07 33.1773 411.846 33.0603 412.243C32.9703 412.55 32.8803 413.353 32.8263 414.318C32.7453 415.842 32.6193 417.141 32.3403 419.414C32.2683 420.01 32.1603 421.209 32.1063 422.075C31.9893 423.843 31.8003 424.953 31.4313 425.954C31.1883 426.622 31.1883 426.658 31.2333 428.119C31.2693 428.967 31.3503 429.86 31.4313 430.194C31.8183 431.808 31.8453 431.592 31.1343 432.638C30.3064 433.865 29.8834 434.298 28.9564 434.902C28.1104 435.444 28.0024 435.579 27.7144 436.355C27.1654 437.807 27.5074 438.294 29.1814 438.483C31.6113 438.745 34.0503 438.195 34.5992 437.257C34.8782 436.779 35.0312 436.688 35.5982 436.688C36.0482 436.688 36.2822 436.634 37.1462 436.3C38.0102 435.976 37.9742 436.093 37.9472 433.351C37.9202 431.033 37.9292 430.951 38.1182 430.6C38.2262 430.401 38.3162 430.176 38.3162 430.094C38.3162 430.013 38.3792 429.788 38.4602 429.598C38.5771 429.319 38.5951 429.066 38.5501 428.299C38.3432 424.736 38.3342 424.799 38.9011 422.617C39.1441 421.669 39.3061 420.858 39.3871 420.181C39.4411 419.811 39.5221 419.216 39.5671 418.873C39.7021 417.989 39.9091 416.14 40.1161 413.912C40.3411 411.494 40.4761 410.8 40.8631 409.979C41.4031 408.842 41.4391 408.662 41.8711 405.09C41.9431 404.504 42.0151 403.998 42.0421 403.953C42.0691 403.917 42.1501 403.556 42.2221 403.169C42.2941 402.781 42.4921 401.906 42.663 401.238C43.095 399.515 43.257 398.821 43.32 398.352C43.374 397.928 43.689 396.241 43.797 395.781C43.941 395.167 44.274 395.474 44.517 396.457C44.571 396.683 44.733 397.305 44.877 397.856C45.021 398.397 45.228 399.272 45.327 399.795C45.435 400.318 45.579 400.986 45.651 401.283C45.768 401.761 45.984 402.835 46.605 406.019C46.695 406.488 46.8299 407.237 46.9109 407.688C46.9829 408.13 47.0909 408.761 47.1539 409.086C47.3519 410.25 47.4959 410.8 47.7569 411.359C48.0089 411.9 48.0179 412 48.0719 413.641C48.1079 414.579 48.1709 415.554 48.2159 415.806C48.2609 416.05 48.3599 417.583 48.4409 419.207C48.5939 422.589 48.6749 423.464 48.9539 425.088C49.1339 426.162 49.1429 426.351 49.0529 427.659C48.9989 428.435 48.9719 429.247 48.9899 429.472C49.0889 430.455 49.0979 430.482 49.8089 431.159C50.2859 431.619 50.4659 431.862 50.4299 431.971C50.4119 432.061 50.3399 432.656 50.2769 433.288C50.1149 435.056 50.2409 435.985 50.7179 436.535C50.8078 436.643 50.8888 436.959 50.9248 437.401C51.0598 438.943 51.7438 439.394 53.9758 439.376C57.5127 439.358 58.1427 438.195 56.4957 434.749C55.6677 433.017 55.4787 432.476 55.4337 431.763C55.3977 431.114 55.3977 431.114 55.9017 430.735C56.6127 430.194 56.7207 429.878 56.4957 429.03C56.1087 427.578 56.0367 427.009 56.0997 425.954C56.1357 425.323 56.1177 424.421 56.0547 423.735C55.9467 422.535 55.8657 420.957 55.6407 416.149C55.5777 414.597 55.4697 413.082 55.4157 412.766C55.2807 412.009 55.0647 411.097 54.9477 410.809C54.9027 410.683 54.8487 409.78 54.8307 408.815C54.8218 407.85 54.7768 406.317 54.7408 405.406C54.6868 404.305 54.6958 403.556 54.7678 403.15C55.1727 400.688 55.2267 398.92 54.9927 395.646C54.8398 393.436 54.8398 393.436 55.0377 392.606C55.2987 391.505 55.2897 391.298 54.9117 390.215C54.5968 389.313 54.5878 389.241 54.5608 387.798C54.5428 386.86 54.4798 386.084 54.3898 385.696C54.1378 384.623 54.1468 384.586 54.9927 383.73C55.6407 383.062 55.8207 382.936 56.4687 382.665C57.4947 382.241 57.7917 381.953 58.4667 380.753C59.1956 379.472 59.1686 379.49 59.9156 379.553C60.6896 379.625 61.0676 379.499 61.5176 379.012C62.2466 378.227 62.4536 377.018 61.9496 376.549C61.6436 376.27 61.6526 376.044 61.9946 375.286C62.4266 374.348 62.9935 372.364 63.1465 371.254C63.5605 368.296 63.0835 366.735 60.6806 363.127C60.1856 362.378 59.7266 361.648 59.6726 361.503C58.2957 357.742 57.6657 356.271 57.2247 355.712C56.7567 355.108 55.1277 354.052 54.1468 353.71C51.8158 352.898 51.2218 352.654 50.7179 352.329C50.0519 351.897 49.9529 351.779 49.4579 350.859C49.2419 350.462 48.8999 349.948 48.6929 349.723C48.4229 349.434 48.3059 349.226 48.3059 349.046C48.3059 348.64 48.8369 347.612 49.5479 346.665C50.3219 345.627 50.4569 345.23 50.2859 344.509C50.2229 344.229 50.1599 343.823 50.1599 343.598C50.1509 343.21 50.1689 343.192 50.4659 343.093C50.9968 342.921 51.0058 342.768 50.5289 342.254C50.2139 341.911 50.1059 341.731 50.1059 341.514C50.1059 341.361 50.0249 340.847 49.9259 340.368C49.4759 338.14 48.8369 337.238 47.0729 336.336C46.641 336.111 46.164 335.786 46.011 335.624C45.579 335.137 45.03 334.983 44.481 335.2ZM55.0557 365.941C55.2177 366.383 55.4427 366.934 55.5507 367.186C55.6587 367.43 55.8207 367.827 55.9017 368.061C56.0997 368.566 56.4327 368.9 56.8557 369.008C57.2427 369.107 57.3057 369.324 57.0447 369.676C56.8197 369.982 56.8107 370.127 56.9997 370.497C57.1707 370.83 57.1167 371.705 56.8737 372.598C56.7747 372.986 56.7297 373.564 56.7207 374.628C56.7117 375.485 56.6667 376.198 56.6127 376.297C56.5587 376.396 56.4237 376.946 56.3157 377.514C55.9647 379.31 55.9467 379.328 54.6058 379.391C53.1748 379.454 53.0128 379.237 53.7958 378.335C54.2908 377.767 54.3268 377.587 54.0748 377.109C53.6788 376.36 53.9668 367.854 54.4798 365.355C54.5608 364.958 54.7588 365.166 55.0557 365.941ZM34.5812 365.355C34.5992 365.418 34.6622 366.14 34.7162 366.961C34.7612 367.781 34.9052 369.08 35.0312 369.847C35.5802 373.158 35.6162 374.051 35.2472 375.169C35.0222 375.864 35.0672 376.649 35.3462 377.109C35.6972 377.677 35.5892 377.857 34.7612 378.146C34.1403 378.362 33.5733 378.38 33.3033 378.191C33.1143 378.056 33.1053 377.984 33.1233 377.118C33.1413 376.179 33.1413 376.17 32.8353 375.746C32.6013 375.404 32.5203 375.178 32.4663 374.718C32.3943 374.096 31.8093 372.183 31.6023 371.877C31.4043 371.606 31.4493 371.236 31.7103 370.957C31.8813 370.776 31.9263 370.65 31.8813 370.479C31.6473 369.54 31.6923 369.324 32.2053 368.846C32.4753 368.593 32.7183 368.368 32.7543 368.332C33.1413 367.971 33.6723 366.952 33.9873 365.986C34.0863 365.68 34.1943 365.382 34.2213 365.337C34.3023 365.211 34.5362 365.229 34.5812 365.355ZM54.3358 383.062C54.3358 383.288 54.0748 383.739 53.9488 383.739C53.6338 383.739 53.5258 383.36 53.7688 383.089C53.9488 382.891 54.3358 382.873 54.3358 383.062Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M109.774 335.362C109.657 335.389 109.387 335.551 109.18 335.731C108.973 335.921 108.469 336.201 108.073 336.363C107.552 336.588 107.192 336.814 106.769 337.211C105.851 338.05 105.545 338.789 105.086 341.279C105.014 341.676 104.915 341.874 104.681 342.109C104.249 342.542 104.357 342.812 105.032 343.056C105.32 343.155 105.338 343.426 105.095 344.319C104.843 345.284 105.221 346.547 105.896 346.971C106.418 347.305 106.706 347.945 106.976 349.442C107.111 350.155 107.057 350.317 106.58 350.615C106.112 350.913 105.518 351.616 105.257 352.185C105.077 352.582 105.023 352.627 104.159 353.033C103.286 353.448 101.441 354.142 100.586 354.377C99.7217 354.62 98.0387 355.576 97.9037 355.892C97.8857 355.937 97.7867 356.063 97.6787 356.172C97.3548 356.496 97.0938 357.299 96.8598 358.752C96.7338 359.518 96.6168 360.249 96.5988 360.375C96.5718 360.502 96.6168 360.835 96.6888 361.115C96.8058 361.575 96.8058 361.701 96.6798 362.17C96.5898 362.522 96.5448 363.117 96.5448 363.938C96.5448 365.057 96.5268 365.21 96.3468 365.499C96.1218 365.869 96.1398 365.995 96.6798 367.637C96.8508 368.178 97.0848 368.909 97.1838 369.26C97.9037 371.723 98.7137 373.031 99.6587 373.265C100.145 373.392 100.271 373.608 100.199 374.158C100.145 374.555 99.8207 375.575 99.6857 375.755C99.5597 375.935 99.3347 376.828 99.3347 377.171C99.3347 377.541 99.4877 377.911 99.8297 378.371C100.145 378.786 100.163 378.984 99.9647 379.417C99.6497 380.112 99.7307 380.509 100.289 381.14C100.46 381.33 100.613 381.582 100.649 381.718C100.748 382.096 100.613 383.467 100.424 384.054C99.9467 385.551 99.6407 387.193 99.3437 389.827C98.7047 395.519 98.5427 401.797 99.0017 403.276C99.1727 403.836 99.1187 412.676 98.9297 413.641C98.8577 414.038 98.7587 415.192 98.7137 416.212C98.6597 417.231 98.5247 419.035 98.4077 420.226C98.2817 421.416 98.1377 423.22 98.0747 424.231C98.0117 425.241 97.9307 426.179 97.8857 426.305C97.7687 426.666 97.4448 428.993 97.4448 429.481C97.4448 430.229 97.8407 431.456 98.2817 432.087C98.4797 432.367 98.4707 432.484 98.2637 432.935C98.1647 433.143 98.0027 433.522 97.9127 433.774C97.4808 434.92 97.0398 435.371 95.8968 435.831C94.8168 436.264 94.5018 436.643 94.2498 437.87C94.0608 438.745 94.0788 438.898 94.3668 439.214C95.3208 440.287 100.838 439.98 101.387 438.835C101.549 438.483 101.783 438.393 102.467 438.384C103.853 438.384 105.077 437.906 105.203 437.31C105.239 437.148 105.221 436.309 105.167 435.47C105.023 433.035 105.086 432.331 105.581 431.14C106.175 429.715 106.202 429.49 106.13 426.314C106.067 423.473 106.193 420.451 106.499 417.384C106.571 416.663 106.688 415.328 106.76 414.407C106.931 412.369 107.03 411.692 107.246 411.214C107.651 410.285 107.785 409.726 107.884 408.499C108.181 404.891 108.235 404.314 108.325 403.944C108.919 401.553 109.459 398.757 109.558 397.611C109.621 396.881 109.783 396.583 109.936 396.881C110.044 397.07 110.575 398.739 110.836 399.704C111.241 401.166 111.331 401.635 111.628 403.854C111.799 405.116 112.033 406.722 112.15 407.417C112.267 408.111 112.411 409.329 112.474 410.123C112.537 410.989 112.663 411.9 112.798 412.423C112.915 412.892 113.05 413.623 113.095 414.047C113.212 415.03 113.446 419.964 113.509 422.706C113.554 424.601 113.581 424.916 113.788 425.683C113.986 426.423 114.022 426.829 114.094 428.66C114.139 429.823 114.211 430.897 114.256 431.05C114.517 431.844 114.724 432.124 115.453 432.638C115.741 432.836 115.903 434.433 115.831 436.255C115.786 437.391 115.795 437.626 115.93 437.906C116.02 438.095 116.119 438.6 116.155 439.105C116.236 440.116 116.407 440.54 116.776 440.621C116.911 440.648 117.199 440.729 117.424 440.81C117.703 440.9 118.36 440.955 119.584 440.991C122.392 441.063 123.085 440.738 123.094 439.331C123.094 439.024 123.04 438.483 122.968 438.113C122.842 437.455 122.752 437.274 121.978 435.93C121.528 435.136 121.204 434.279 121.204 433.846C121.204 433.531 121.537 432.62 121.861 432.051C122.257 431.384 122.338 430.852 122.212 429.76C121.978 427.749 121.924 426.783 121.834 422.751C121.645 414.886 121.609 414.317 121.303 413.244C120.97 412.116 120.952 411.647 121.222 410.006C121.402 408.824 121.411 408.752 121.267 408.048C120.862 406.055 120.871 405.252 121.312 402.275C121.519 400.886 121.501 397.972 121.285 397.224C121.213 396.989 121.168 395.907 121.159 394.202C121.141 392.019 121.114 391.442 120.988 391C120.538 389.412 120.475 388.907 120.628 388.311C120.943 387.094 120.565 384.947 119.647 382.845C119.305 382.051 119.287 381.943 119.278 381.122C119.269 380.238 119.269 380.238 119.863 379.616C120.655 378.795 120.745 378.254 120.205 377.559C120.016 377.325 120.007 377.288 120.106 375.908C120.178 374.979 120.178 374.276 120.124 373.861C119.971 372.715 119.998 372.661 120.637 372.607C121.69 372.517 121.96 372.084 122.734 369.26C122.923 368.566 123.211 367.691 123.364 367.321C123.931 365.968 124.093 365.436 124.039 365.084C123.94 364.489 123.625 362.964 123.427 362.134C123.274 361.503 123.238 361.106 123.256 360.321C123.265 359.771 123.238 359.212 123.193 359.085C123.148 358.959 123.04 358.472 122.959 357.994C122.815 357.146 122.59 356.623 122.113 355.973C121.87 355.658 120.241 354.512 120.025 354.512C119.953 354.512 119.854 354.476 119.809 354.431C119.674 354.295 118.081 353.52 117.559 353.339C116.83 353.069 115.498 352.509 115.381 352.419C115.318 352.374 115.192 352.122 115.093 351.86C114.796 351.066 114.409 350.561 114.004 350.453C113.491 350.317 113.482 350.137 113.905 348.685C114.265 347.44 114.274 347.431 114.769 346.98C115.651 346.177 116.02 344.959 115.624 344.175C115.381 343.669 115.489 343.453 116.164 343.074C116.686 342.794 116.686 342.776 116.389 342.389C116.272 342.235 116.128 341.874 116.065 341.604C115.444 338.618 114.553 337.193 112.798 336.39C112.384 336.192 111.826 335.867 111.574 335.668C111.097 335.289 110.611 335.208 109.774 335.362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/Construction.88d7137ae5c98f86dd4753eec1b0bf52.svg";
export { ForwardRef as ReactComponent };